<!-- 赌球竞猜 游戏币版--->
<template>
<div class="guessing" v-loading="pageLoading">
    <div class="top-contrl cont-row">
        <div class="flex-cont cont-row tab">
            <div class="item" :class="{active:indent == 1}" @click="tabChange(1)">世界杯竞猜</div>
            <div class="item" :class="{active:indent == 2}"  @click="tabChange(2)">历史竞猜</div>
        </div>
        <div class="rules" @click="ruleStatus = true">竞猜规则&gt;</div>
    </div>
    <ul class="game-list" >
        <!-- <li><a href="/fifaworldcupvip" target="_blank" class="vip-cursor">
            <img class="vip-pc" :src="require('../assets/vip-game.png')" alt="">
            <img class="vip-m" :src="require('../assets/vip-game-m.png')" alt="">
        </a></li> -->
        <li v-for="item in list.slice(0,showLg)" :key="item.id">
            <GuessingItem :info="item"  @success="emitSuccess" />
        </li>
         
    </ul>
    <div class="no-data" v-if="list.length == 0"><img :src="require('../assets/no-game.png')" height="50" alt=""></div>
   <!--  <div class="look-more" @click="foldChange(false)" v-if="foldStatus">查看全部 <i class="el-icon-arrow-down"></i></div>
    <div class="look-more" @click="foldChange(true)"  v-if="!foldStatus">收起 <i class="el-icon-arrow-up"></i></div> -->
    <GuessingRules :status.sync="ruleStatus" />
   
</div>
</template>
<script>
import GuessingItem from './guessing-item.vue'
import GuessingRules from '../dialog/guessing-rules.vue'

export default {
    name:'Guessing',
    components:{GuessingItem,GuessingRules},
    data(){
        return {
            pageLoading:false,
            ruleStatus:false,
            foldStatus:true,
            indent:1,
            list:[],
            showLg:10,
        }
    },
    created(){
        this.getList();
    },
    methods:{
        foldChange(bool){
            this.foldStatus = bool;
            if( this.foldStatus ){
                this.showLg = 10;
            }else{
                this.showLg = this.list.length;
            }
        },
        tabChange(index){
            if( this.indent == index) return false;
            this.indent = index;
            this.getList()
        },
        emitSuccess(){
            this.$emit('success')
        },
        async getList(){
            let url = ''
            if( this.indent == 1 ){
                url = '/worldcup2022/game/coin/result/games/ongoing?cointype=1'
            }else{
                url = '/worldcup2022/game/coin/result/games/history?cointype=1'
            }

            this.pageLoading = true;
            let result = await this.$axios.get(url);
            this.pageLoading = false;
            console.log('赌球列表+===》',result)
            if(result.code == 0 ){
                this.list = result.data.games;
            }
        },
    }
}
</script>
<style lang="less" scoped>
.guessing{
    background:url(../assets/bg.png) repeat-y  blue; padding: 40px 30px 20px; margin-bottom: 30px;
    .top-contrl{margin-bottom: 20px;}
    .tab{
        align-items: center; 
        .item{
            font-size: 16px; line-height: 24px; color: #fff; opacity: 0.7; margin-right: 30px; user-select: none; cursor: pointer;
            &.active{font-size: 20px; line-height: 30px; opacity: 1;}
        }
    }
    .rules{font-size: 16px; line-height: 24px; color: #fff; opacity: 0.7; cursor: pointer;}
    .game-list{
        margin:0 -12px; display: flex; flex-wrap: wrap;
        li{
            padding: 0 12px; margin-bottom: 30px; width: 50%; box-sizing: border-box;
            .vip-cursor{
                display: block;overflow:hidden; border-radius: 8px;
                &:hover{
                    img{transform: scale(1.05); transition: all 200ms linear;}
                }
            }

        }
    }
    .look-more{width: 100%;
        border-radius: 4px; font-size: 16px; line-height: 36px; color: #fff; text-align: center;
        user-select: none; cursor: pointer;
        &:hover{text-decoration: underline;}
    }
}
.no-data{
    img{display: block; margin:0 auto;}
}
.vip-pc{display:block}
.vip-m{display: none;}
@media screen and (max-width:768px){
    .guessing{
        padding: 12px 7px; margin-bottom: 20px;
        .game-list{
            li{width:100%; margin-bottom: 20px;}
        }
    }

    .vip-pc{display:none}
    .vip-m{display: block;}
}
</style>